module.exports = __webpack_public_path__ + "static/media/copy-code-google.327c769a.webm";